import React from 'react';

import { StandardButton } from '@eika/button';
import { InfoCard } from '@eika/card';
import { RichIcon, RichIconTypes } from '@eika/rich-icon';

import { Piwik, SiteCoreDictionary } from '../../types';

interface ReadMoreCardProps {
    onClickMoreInfo: () => void;
    dictionary: SiteCoreDictionary;
    piwik: Piwik | undefined;
}

const ReadMoreCard = ({ onClickMoreInfo, dictionary, piwik }: ReadMoreCardProps) => {
    const { visaCalculatorReadMoreText, visaCalculatorReadMoreButton } = dictionary;

    return (
        <InfoCard skipBackground>
            <RichIcon type={RichIconTypes.KALKULATOR} />
            <p>{visaCalculatorReadMoreText}</p>
            <StandardButton
                data-track-id={piwik?.visaCalculator?.visaExchangeCalculatorReadMoreCardButton?.dataTrackId}
                data-track-linkname={piwik?.visaCalculator?.visaExchangeCalculatorReadMoreCardButton?.dataTrackLinkname}
                id={piwik?.visaCalculator?.visaExchangeCalculatorReadMoreCardButton?.dataTrackId}
                onClick={() => onClickMoreInfo()}
            >
                {visaCalculatorReadMoreButton}
            </StandardButton>
        </InfoCard>
    );
};

export default ReadMoreCard;
